export default __webpack_public_path__ + "static/media/ic_liquidity.f00d35e4.svg";